/*
This file is generated.
Do not modify manually, instead refer to build-sounds.js
*/
// tslint:disable
/* es-lint:disable */
import { utilVersion } from "../utils/utilVersion";
export var assetBundleSoundMusic = {
    ogg: process.env.PUBLIC_URL + "/sound/sound-Music.ogg?v=" + utilVersion.getCurrentVersion(),
    m4a: process.env.PUBLIC_URL + "/sound/sound-Music.m4a?v=" + utilVersion.getCurrentVersion(),
    mp3: process.env.PUBLIC_URL + "/sound/sound-Music.mp3?v=" + utilVersion.getCurrentVersion(),
    ac3: process.env.PUBLIC_URL + "/sound/sound-Music.ac3?v=" + utilVersion.getCurrentVersion(),
};



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/assetBundleSoundMusic.ts
// module id = 2514
// module chunks = 3